export default __webpack_public_path__ + "static/media/icons8-tag-100.f78aa19b.svg";